import axios, { AxiosResponse } from 'axios'
import { BaseDataObject } from '../apis/ApiBase'
import { showToast } from 'vant';

export const urls: ConfigFile = (process.env.NODE_ENV === 'development' ? {
   baseUrl: "http://mpyx.ippyu.com/"
  // baseUrl:"http://192.168.10.187:35100"
} : window.config)

axios.defaults.baseURL = urls.baseUrl


axios.interceptors.request.use(config => {
  //附加参数
  let data = {};
  try {
    data =  JSON.parse(window.android.getCommonParams());
    config.headers.Authorization = 'bearer '+  JSON.parse(window.android.getUserJson()).token.token;
  } catch (error) {
    data={}
  }
  // const data = {
  //   oaid: '',//getMsaOaid
  //   keycode: "EA12D50D1376794008466F4EF2B3C487",//getKeyCode
  //   deviceId:"b83ca7fa-bf22-4a9e-b90c-b4661eefa2bd",//getDeviceId
  //   sdkInt:29,//getOSVersionCode
  //   userId: 138,
  //   packageName :"com.jiuyou.caibeiwan",
  //   phoneType: 2,
  // }
  // config.headers.Authorization = 'bearer '+ "3a89a368-c19c-45ee-81d4-ed0322d5db1c";

  config.params = Object.assign({}, data, config.params, {
    t: Math.random()
  })
  if (config.params['noLoading']) {
    delete config.params['noLoading']
    return config
  }
  return config
})

axios.interceptors.response.use((response: AxiosResponse<BaseDataObject>) => {
  // 如果请求的域名不是我要的，那就放行到下一个拦截器
  if(response.config.url){
    if(response.config.url.startsWith('http')){
      return response
    }
  }
  const data = response.data
  if (data.status == 0) {
    return response
  }
  showToast(data.view)
  return Promise.reject(new Error(data.view))
}, error => {
  if(error.response){
    showToast(error.response.data.view)
  }else{
    showToast('您当前的网络较差，请切换网络后再来刷新......')
  }
  return Promise.reject(error)
})
